/**
 * Módulo Aplicativo ZehMotoca — acesso via `allowedModules` (mesmo padrão do Painel Oficina).
 */

import { UserRole } from '@/types';

export const APLICATIVO_HREF = '/configuracoes/aplicativo-zehmotoca';
export const PUSH_HREF = '/push-notifications';

const APLICATIVO_MODULE_HREFS = [APLICATIVO_HREF, PUSH_HREF] as const;

export function allowedModulesIncludeAplicativo(
  allowedModules: string[] | null | undefined
): boolean {
  if (!Array.isArray(allowedModules) || allowedModules.length === 0) return false;
  return APLICATIVO_MODULE_HREFS.some((h) => allowedModules.includes(h));
}

/**
 * Acesso às rotas / API do Aplicativo: admin sempre; gestor sem lista ou com módulo;
 * operador só se a lista incluir aplicativo e/ou push.
 */
export function userCanAccessAplicativo(
  role: UserRole,
  allowedModules?: string[] | null
): boolean {
  if (role === UserRole.ADMIN) return true;
  const restricted = Array.isArray(allowedModules) && allowedModules.length > 0;
  if (role === UserRole.GESTOR) {
    if (!restricted) return true;
    return allowedModulesIncludeAplicativo(allowedModules);
  }
  if (role === UserRole.OPERADOR) {
    if (!restricted) return false;
    return allowedModulesIncludeAplicativo(allowedModules);
  }
  return false;
}

/** Home pós-login: usuário só com módulos do Aplicativo (sem dashboard). */
export function userHomeIsAplicativo(allowedModules: string[] | null | undefined): boolean {
  if (!Array.isArray(allowedModules) || allowedModules.length === 0) return false;
  if (allowedModules.includes('/dashboard')) return false;
  if (!allowedModulesIncludeAplicativo(allowedModules)) return false;
  const aplicativoSet = new Set<string>(APLICATIVO_MODULE_HREFS);
  return allowedModules.every((href) => aplicativoSet.has(href));
}
